import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';

import { BehaviorSubject, Observable, of, EMPTY, from, Subject } from 'rxjs';

import { mergeMap, take, catchError, map } from 'rxjs/operators';

import { ServiceproviderService } from '../serviceprovider.service';
import { OrdersService } from '../orders.service';
import { EmailService } from '../email.service';

@Injectable({
  providedIn: 'root',
})
export class Serviceproviderdetails implements Resolve<any> {
  constructor(private router: Router, private cs: ServiceproviderService, private os: OrdersService, private es: EmailService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let customerid = route.paramMap.get('id');
    var customerdata = this.cs.getServiceProviderPk(customerid).pipe(
      map((response: any) => {
        response = response;
        var userorder = [], emailsent = [];
        this.os.getUserOrders(response.publicKey).subscribe(orders => {
          for (var li in orders) {
            userorder.push(orders[li]);
          }
        });

        this.es.getUserEmailSent(response.publicKey).subscribe(emails => {
          for (var li in emails) {
            emails[li]["isExpanded"] = true;
            emailsent.push(emails[li]);
          }
        });
        response["order"] = userorder;
        response["emailsent"] = emailsent;
        return response;

      })
    );
    return customerdata;
  }
}
